import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AccountsHubSpotUploader from "../../../components/CampaignCreation/AccountsHubSpotUploader";
import CampaignCreationSlideContainer from "../../../components/CampaignCreation/CampaignCreationSlideContainer";
import CompaniesDashboard from "./CompaniesDashboard";
import { PageStepComponentProps } from "../../../components/modules/BaseStepper/BaseStepper";
import { ReduxApplicationState } from "../../../types/ReduxTypes/ReduxApplicationState";
import { errorToaster } from "../../../helpers/toasters";
import { setCampaignToCreateSelectedAdvertiser } from "../../../redux/reducers/campaignToCreate";

const SelectHubspotTargetCompaniesSlide: FC<PageStepComponentProps> = ({
  isAttemptingToGoNext,
  setIsAttemptingToGoNext,
  handleNext,
}) => {
  const [tierValue, setTierValue] = useState<string[]>([]);
  const [areTargetAccountsOnly, setAreTargetAccountsOnly] = useState<boolean>(false);
  const [areCompaniesLoading, setAreCompaniesLoading] = useState<boolean>(false);

  const dispatch = useDispatch();

  const selectedAdvertiser = useSelector((state: ReduxApplicationState) => state.campaignToCreate.selectedAdvertiser);

  const apiError = useSelector((state: ReduxApplicationState) => state.apiError);

  const [selectedBgAdvertiserId, setSelectedBgAdvertiserId] = useState("");
  const advertisers = useSelector((state: ReduxApplicationState) => state.agency.advertisers);

  const isCompanySortValuesPending = useSelector((state: ReduxApplicationState) => state.campaignToCreate.isPending);

  const foundCompaiesInfo = useSelector((state: ReduxApplicationState) => state.campaignToCreate.foundCompanyInfo);

  useEffect(() => {
    if (apiError.apiError) errorToaster(apiError.apiError, 5000);
  }, [apiError]);

  useEffect(() => {
    if (isAttemptingToGoNext && handleNext && setIsAttemptingToGoNext) {
      handleNext();
      setIsAttemptingToGoNext(false);
    }
  }, [foundCompaiesInfo, handleNext, isAttemptingToGoNext, setIsAttemptingToGoNext, tierValue]);

  useEffect(() => {
    if (!selectedBgAdvertiserId && setIsAttemptingToGoNext) return;

    const findedAdvertiser = advertisers.find(
      (advertiser) => advertiser.brandgenAdvertiserId === selectedBgAdvertiserId,
    );

    if (findedAdvertiser) dispatch(setCampaignToCreateSelectedAdvertiser(findedAdvertiser));
  }, [advertisers, dispatch, selectedBgAdvertiserId, setIsAttemptingToGoNext]);

  const mainContent = () => (
    <>
      <AccountsHubSpotUploader
        selectedBgAdvertiserId={selectedBgAdvertiserId}
        setSelectedBgAdvertiserId={setSelectedBgAdvertiserId}
        setAreCompaniesLoading={setAreCompaniesLoading}
        isStepInCampaignCreation={!!setIsAttemptingToGoNext}
        hubSpotSelectorButtonLabel="Get Accounts"
        tierValue={tierValue}
        setTierValue={setTierValue}
        areCompaniesLoading={areCompaniesLoading}
        areTargetAccountsOnly={areTargetAccountsOnly}
        setAreTargetAccountsOnly={setAreTargetAccountsOnly}
      />

      {!isCompanySortValuesPending && (
        <CompaniesDashboard
          tierValue={tierValue}
          areTargetAccountsOnly={areTargetAccountsOnly}
          areCompaniesLoading={areCompaniesLoading}
          primarySegments={foundCompaiesInfo?.primarySegments ?? []}
          uniqueSegments={foundCompaiesInfo?.uniqueSegments ?? []}
        />
      )}
    </>
  );

  return (
    <div
      style={{
        padding: !setIsAttemptingToGoNext ? "4rem" : 0,
      }}
    >
      {setIsAttemptingToGoNext ? (
        <CampaignCreationSlideContainer
          heading={selectedAdvertiser?.hubspot_authed ? "Select HubSpot Target Companies" : ""}
        >
          {mainContent()}
        </CampaignCreationSlideContainer>
      ) : (
        mainContent()
      )}
    </div>
  );
};

export default SelectHubspotTargetCompaniesSlide;
